module.exports = __webpack_public_path__ + "4b8d4d77d3836b6ac2f434a99a9ea1e5.pdf";